import { render, staticRenderFns } from "./DistributionPoinComponent.vue?vue&type=template&id=e872e122&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DistributionPoinComponent.vue?vue&type=script&lang=js&"
export * from "./DistributionPoinComponent.vue?vue&type=script&lang=js&"
import style0 from "./DistributionPoinComponent.vue?vue&type=style&index=0&id=e872e122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e872e122",
  null
  
)

component.options.__file = "DistributionPoinComponent.vue"
export default component.exports